(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rnaclth-catalog"]) return;
  try {
    
document.querySelectorAll('[data-rna-catalog]').forEach(root=>{
const form=root.querySelector('[data-rna-form]'),input=form.querySelector('[name=q]'),status=root.querySelector('[data-rna-status]');
let controller,version=0;
const collectionUrl=root.dataset.collectionUrl;
const searchUrl=term=>{const u=new URL(root.dataset.searchUrl,location.origin);const clean=term.replace(/["():\\]/g,' ').trim();u.searchParams.set('q','tag:rnaclth-tee AND ('+clean+')');u.searchParams.set('type','product');u.searchParams.set('options[prefix]','last');u.searchParams.set('view','rnaclth-tees');return u;};
async function load(url,term,updateHistory=true){
if(controller)controller.abort();controller=new AbortController();const current=++version;
const old=root.querySelector('[data-rna-results]');old.setAttribute('aria-busy','true');status.textContent=root.dataset.loading;
try{const response=await fetch(url,{signal:controller.signal});if(!response.ok)throw new Error('search');const html=await response.text();if(current!==version)return;const doc=new DOMParser().parseFromString(html,'text/html');const next=doc.querySelector('[data-rna-results]');if(!next)throw new Error('results');old.replaceWith(next);status.textContent='';if(updateHistory){const address=new URL(location.href);if(term)address.searchParams.set('q',term);else address.searchParams.delete('q');address.searchParams.delete('page');history.replaceState(null,'',address);} }
catch(error){if(error.name==='AbortError')return;old.removeAttribute('aria-busy');status.textContent=root.dataset.error;}
}
form.addEventListener('submit',event=>{event.preventDefault();const term=input.value.trim();load(term?searchUrl(term):collectionUrl,term);});
root.querySelector('[data-rna-clear]').addEventListener('click',event=>{event.preventDefault();input.value='';load(collectionUrl,'');});
root.addEventListener('click',event=>{const a=event.target.closest('.rna-pagination a');if(!a)return;event.preventDefault();load(a.href,input.value.trim(),false);root.querySelector('[data-rna-results]').scrollIntoView({block:'start'});});
if(location.pathname.includes('/collections/')){const term=new URL(location.href).searchParams.get('q');if(term){input.value=term;load(searchUrl(term),term,false);}}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rnaclth-product"]) return;
  try {
    
document.querySelectorAll('[data-rna-product]').forEach(root=>{const track=root.querySelector('.rna-slides'),slides=[...track.children],thumbs=[...root.querySelectorAll('[data-slide]')],prev=root.querySelector('[data-prev]'),next=root.querySelector('[data-next]');let current=0;function update(){current=Math.round(track.scrollLeft/track.clientWidth);prev.disabled=current===0;next.disabled=current===slides.length-1;root.querySelector('[data-counter]').textContent=(current+1)+' / '+slides.length;thumbs.forEach((b,i)=>b.setAttribute('aria-current',String(i===current)));}function go(i){track.scrollTo({left:Math.max(0,Math.min(slides.length-1,i))*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}prev.addEventListener('click',()=>go(current-1));next.addEventListener('click',()=>go(current+1));thumbs.forEach((b,i)=>b.addEventListener('click',()=>go(i)));track.addEventListener('scroll',update,{passive:true});track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(current+(e.key==='ArrowRight'?1:-1));}});update();root.querySelector('select').addEventListener('change',e=>{const option=e.target.selectedOptions[0];root.querySelector('[data-price]').textContent=option.dataset.price;root.querySelector('.rna-add').disabled=option.dataset.available!=='true';const u=new URL(location.href);u.searchParams.set('variant',e.target.value);history.replaceState(null,'',u);});});

  } catch(e) { console.error(e); }
})();
})();
